
$(function () {
    $(".widget-pwd-val").each(function (idx, element) {
        var inputId = $(element).data("element");
        var minLength = parseInt($(element).data("min-length"));
        var disableSelector = $(element).data("disabled-selector");

        if (inputId) {
            var $input = $("#" + inputId);

            if ($input && $input.length == 1) {

                if (minLength > 0) {
                    $input.attr("data-val-length-min", minLength);
                    $input.attr("data-val-length", "The password must be at least " + minLength.toString()
                    + " characters long");
                }

                $input.on("keyup paste", function () {

                    $(element).find(".pwd-req .fa-check-circle").hide();
                    $(element).find(".pwd-req .fa-exclamation-triangle").show();

                    var value = $(this).val();
                    var i = 0;
                    var char = "";
                    var isLengthValid = false;
                    var hasCaps = false;
                    var hasSym = false;
                    var hasDigit = false;

                    if (value.length >= minLength) {
                        $(element).find(".pwd-req-length .fa-check-circle").show();
                        $(element).find(".pwd-req-length .fa-exclamation-triangle").hide();
                        isLengthValid = true;
                    }

                    while (i <= value.length) {
                        char = value.charAt(i);

                        if (char === char.toUpperCase() && char !== char.toLowerCase()) {
                            $(element).find(".pwd-req-cap .fa-check-circle").show();
                            $(element).find(".pwd-req-cap .fa-exclamation-triangle").hide();
                            hasCaps = true;
                        }

                        if (/^[0-9]$/.test(char.toString().trim()) == true) {
                            $(element).find(".pwd-req-dig .fa-check-circle").show();
                            $(element).find(".pwd-req-dig .fa-exclamation-triangle").hide();
                            hasDigit = true;
                        }

                        if (/^[a-zA-Z0-9- ]*$/.test(char) == false) {
                            $(element).find(".pwd-req-sym .fa-check-circle").show();
                            $(element).find(".pwd-req-sym .fa-exclamation-triangle").hide();
                            hasSym = true;
                        }

                        i++;
                    }

                    if (disableSelector) {
                        if (hasSym && hasCaps && hasDigit && isLengthValid)
                            $(disableSelector).prop("disabled", false);
                        else
                            $(disableSelector).prop("disabled", true);
                    }
                });
            }
        }
    });
})